import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Badge,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label,
  Row,
} from "reactstrap";
import Loader from "../../common/Loader";
import APIPortalTable from "../../common/Table/APIPortalTable";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  useParams,
  useRouteMatch,
  useHistory,
} from "react-router-dom";
import TicketDetails from "./TicketDetails";
import {
  FreshDeskSelect,
  Priority,
  PriorityComponent,
  Status,
  StatusComponent,
} from "./Freshdesk";
import {
  faArrowAltCircleRight,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightLong,
  faBackspace,
  faBuilding,
  faClose,
  faFilter,
  faInbox,
  faMessage,
  faMinus,
  faSearch,
  faSync,
  faTicket,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonIcon from "../../common/ButtonIcon";
import { useRef } from "react";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import SikkaSelect from "../../common/SikkaSelect/SikkaSelect";
import SoftBadge from "../../common/SoftBadge";
import { PrioritySelect } from "./FreshdeskCommon";
import apiCall from "../../../services/apiCall";
import AppContext from "../../../context/Context";
import { ToastPosition, toast } from "react-toastify";

const getDateByNumbers = (days) => {
  const currentDate = new Date();
  let whichDays = days;
  let previousDate = new Date(currentDate);
  previousDate.setDate(currentDate.getDate() - whichDays);

  let properFormattedDate = previousDate.toISOString().split("T")[0];

  return properFormattedDate;
};
const priorityData = [
  { id: 1, label: "low" },
  { id: 2, label: "medium" },
  { id: 3, label: "high" },
  { id: 4, label: "urgent" },
];
const statusData = [
  { label: "Open", id: 2 },
  { label: "Pending", id: 3 },
  { label: "Resolved", id: 4 },
  { label: "Closed", id: 5 },
];
const makeQuery = (params, keyName, whichType) => {
  whichType = whichType || "";
  if (whichType === "date") {
    let query = "";

    console.log("keyName", keyName, params);
    params?.map((item, itemIndex) => {
      if (itemIndex === 0) {
        query = "(";
      }
      const addSymbol = ["Today"].includes(item?.label) ? "" : "<";

      if (item?.value || item?.value === 0) {
        if (itemIndex < params.length - 1) {
          query =
            query +
            `${keyName}:${addSymbol}'${getDateByNumbers(
              Number(item?.value)
            )}' OR `;
        } else {
          query =
            query +
            `${keyName}:${addSymbol}'${getDateByNumbers(
              Number(item?.value)
            )}')`;
        }
      } else {
        query = query;
      }
    });
    return query;
  } else {
    let query = "";
    params?.map((item, itemIndex) => {
      if (itemIndex === 0) {
        query = "(";
      }
      if (item?.value || item?.value === 0) {
        if (itemIndex < params.length - 1) {
          query = query + `${keyName}:${item?.value} OR `;
        } else {
          query = query + `${keyName}:${item?.value})`;
        }
      } else {
        query = query;
      }
    });
    return query;
  }
};

const QueryList = [
  { name: "Unresolved", query: `(status:2 AND status:3)` },
  {
    name: "Overdue",
    query: `(due_by:<'${getDateByNumbers(0)}') AND (status:2 OR status:3)`,
  },
  {
    name: "Due Today",
    query: `(due_by:'${getDateByNumbers(0)}') AND (status:2 OR status:3)`,
  },
  {
    name: "Open",
    query: `(status:2 AND status:10 AND status:11 AND status:12 )`,
  },
  { name: "On Hold", query: `(status:8)` },
];

const Tickets = ({
  allTickets,
  isLoading,
  FetchData,
  HeaderTitle,
  backButton,
  setIsLoading,
  CompanyName,
  setAllTickets,
  actions,
  response,
  setResponse,
  companyid,
}) => {
  companyid = companyid || "";
  const { loginUserDetails, isDark } = useContext(AppContext);
  const [selected_status, setSelected_status] = useState(null);

  useMemo(() => {
    if (sessionStorage.getItem("selected_status")) {
      setSelected_status(sessionStorage.getItem("selected_status"));
    } else {
      setSelected_status(null);
    }
  }, [sessionStorage.getItem("selected_status")]);

  let TempColumns = [
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      enableResizing: true,
      size: 500,
      sort: true,
      csvExport: true,
      accessorKey: "subject",
      header: "Subject",
      Cell: ({ cell, row }) => {
        return (
          <>
            <Link
              to={`${process.env.PUBLIC_URL}/${
                loginUserDetails.is_partner == "1"
                  ? `user/support/tickets/${row.original.id}`
                  : `admin/support/freshdesk/${row.original.id}`
              }`}
              // target="_blank"
            >
              {cell.getValue()}
            </Link>
          </>
        );
      },
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "priority",
      header: "Priority",
      Cell: ({ cell, row }) => {
        let realIndex = Priority.findIndex(
          (item) => `${item.id}` === cell.getValue()
        );
        return (
          <>
            <PrioritySelect
              title={Priority[realIndex]?.lable}
              color={Priority[realIndex]?.color}
              data={Priority[realIndex]?.data}
            />
          </>
        );
      },
      enableColumnFilter: true,
      filterFn: (row, id, filterValue) => {
        let priorityValue = Priority.find((item) => {
          return item?.id == row.getValue(id);
        });
        return (
          priorityValue?.lable?.toLowerCase() === filterValue?.toLowerCase()
        );
      },
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "status",
      header: "Status",

      Cell: ({ cell, row }) => {
        let getStatusIndex = Status.findIndex(
          (item) => `${item.id}` === cell.getValue()
        );
        return (
          <>
            <SoftBadge bg={Status[getStatusIndex]?.color}>
              {Status[getStatusIndex]?.lable}
            </SoftBadge>
          </>
        );
      },
      enableColumnFilter: true,
      filterFn: (row, id, filterValue) => {
        let statusValue = statusData.find((item) => {
          return item?.id == row.getValue(id);
        });
        return statusValue?.label?.toLowerCase() === filterValue?.toLowerCase();
      },
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "created_at",
      header: "Created",
      Cell: ({ cell, row }) => {
        let date = new Date(cell.getValue()).toDateString();
        return (
          <>
            <SoftBadge bg="warning">
              <span>{date}</span>
            </SoftBadge>
          </>
        );
      },
      sortingFn: (rowA, rowB, columnId) => {
        let dateA = Date.parse(rowA?.original[columnId]);
        let dateB = Date.parse(rowB?.original[columnId]);
        if (dateA < dateB) {
          return -1;
        } else if (dateA > dateB) {
          return 1;
        } else {
          return 0;
        }
      },
    },
    {
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      accessorKey: "due_by",
      header: "Due By",
      Cell: ({ cell, row }) => {
        let date = new Date(cell.getValue()).toDateString();
        return (
          <>
            <SoftBadge bg="danger">
              <span>{date}</span>
            </SoftBadge>
          </>
        );
      },
      sortingFn: (rowA, rowB, columnId) => {
        let dateA = Date.parse(rowA?.original[columnId]);
        let dateB = Date.parse(rowB?.original[columnId]);
        if (dateA < dateB) {
          return -1;
        } else if (dateA > dateB) {
          return 1;
        } else {
          return 0;
        }
      },
    },
  ];
  const [columns, setColumns] = useState(TempColumns);
  const [isFilterShow, setIsFilterShow] = useState(false);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });

  const [FilterValue, setFilterValue] = useState({});
  const [customLink, setCustomLink] = useState("");
  const [companies, setCompanies] = useState([]);
  const [isCompanyLoading, setisCompanyLoading] = useState(true);

  const defaultSelectedCompany = sessionStorage.getItem("lastSelected")
    ? JSON.parse(sessionStorage.getItem("lastSelected"))
    : {
        value: "All",
        label: "All",
      };
  const [selectedCompany, setSelectedCompany] = useState(
    defaultSelectedCompany
  );

  const [RefreshButtonLabel, setRefreshButtonLabel] = useState(
    "Refresh All Data"
  );
  const [pageNumber, setPageNumber] = useState(1);

  const DateKeys = ["due_by", "fr_due_by", "created_at", "updated_at"];

  useEffect(() => {
    const getKeys = Object.keys(FilterValue);
    const OnlyValueContainsKeys = getKeys.filter((item) => {
      let keyValues = FilterValue[item];
      if (keyValues.length > 0) {
        return item;
      }
    });
    let customLinkBuild =
      CompanyName || selectedCompany.label !== "All"
        ? `company_name:"${CompanyName || selectedCompany.label}" ${
            OnlyValueContainsKeys.length > 0 ? "AND" : ""
          } `
        : "";

    const makeAndQuery = () => {
      let custom = "";
      OnlyValueContainsKeys.map((key, keyIndex) => {
        let keyValues = FilterValue[key];
        // if (keyValues.length > 0) {
        if (keyIndex < OnlyValueContainsKeys.length - 1) {
          if (DateKeys.includes(key)) {
            custom = custom + ` ${makeQuery(keyValues, key, "date")} AND`;
          } else {
            custom = custom + ` ${makeQuery(keyValues, key)} AND`;
          }
        } else {
          if (DateKeys.includes(key)) {
            custom = custom + ` ${makeQuery(keyValues, key, "date")}`;
          } else {
            custom = custom + ` ${makeQuery(keyValues, key)}`;
          }
        }
      });

      return custom;
    };
    const makeAndQueryValue = makeAndQuery();
    setCustomLink(`${customLinkBuild}${makeAndQueryValue}`);
  }, [FilterValue, CompanyName, selectedCompany]);

  const FetchFilterAPI = (optionalValue) => {
    sessionStorage.removeItem("selected_status");
    setIsLoading(true);
    let params = {
      link: `"${customLink.trim()}"`,
    };
    if (
      typeof optionalValue !== "object" &&
      typeof optionalValue === "string"
    ) {
      params = {
        link: `"${optionalValue.trim()}"`,
      };
    }

    let decodedURL = params.link;
    if (decodedURL !== `""`) {
      apiCall
        .servertrip("GET", "freshdesk_tickets_filter", loginUserDetails, params)
        .then(
          (res) => {
            const items = res.data?.items;
            setAllTickets(items);
            setIsLoading(false);
          },
          (error) => {
            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
            setIsLoading(false);
            setAllTickets([]);
            toast.error(resMessage);
          }
        );
    } else {
      toast.error("Please select atleast one Options.");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selected_status && CompanyName) {
      let findStatusIndex = QueryList.findIndex(
        (item) => item.name === selected_status
      );
      let formatQuery =
        `company_name:'${CompanyName}' AND ` + QueryList[findStatusIndex].query;

      setCustomLink(formatQuery);
      FetchFilterAPI(formatQuery);
      setIsFilterShow(true);
      // sessionStorage.removeItem("selected_status");
    } else {
      if (!selected_status && !CompanyName && selectedCompany.value === "All") {
        FetchData(null, 100, 1, 1000);
      }
    }
  }, [selected_status, CompanyName, selectedCompany]);

  const isActionAllowed = (actionName) => {
    // actionName is name of controlID
    let particularAction = actions?.handlers?.find(
      (aName) => aName === actionName
    );
    if (particularAction) return true;
    else return false;
  };

  const FetchCompanies = () => {
    let params={
      user_dev_id:loginUserDetails.dev_id
    }
    setisCompanyLoading(true);
    apiCall.servertrip("GET", "freshdesk_all_companies", loginUserDetails,params).then(
      (res) => {
        const items = res.data.items;
        setisCompanyLoading(false);
        const itemOptions = [{ id: "All", name: "All" }, ...items].map(
          (item) => {
            return {
              value: item?.id,
              label: item?.name,
            };
          }
        );
        setCompanies(itemOptions);
      },
      (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        setisCompanyLoading(false);
        toast.error(resMessage);
      }
    );
  };
  useEffect(() => {
    if (
      isActionAllowed("liFreshdeskCompaniesButton") &&
      loginUserDetails?.is_partner === "0"
    ) {
      FetchCompanies();
    }
  }, []);
  const FetchCompanyTickets = (useCompanyId, per_page, page, maxData) => {
    setIsLoading(true);
    let params = {
      company_id: useCompanyId || loginUserDetails?.freshdesk_id,
      per_page_data: per_page,
      page_number: page,
      max_data: maxData,
      // how_much: "all",
    };

    apiCall
      .servertrip("GET", "freshdesk_company_tickets", loginUserDetails, params)
      .then(
        (res) => {
          const items = res.data.items;
          setResponse(res.data);
          setAllTickets(items);
          setIsLoading(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setIsLoading(false);
          toast.error(resMessage);
        }
      );
  };
  useEffect(() => {
    if (isFilterShow) {
      setRefreshButtonLabel("Refresh Filter Data");
    } else {
      if (loginUserDetails?.is_partner === "0") {
        if (
          selectedCompany.value &&
          selectedCompany.label &&
          selectedCompany.value !== "All"
        ) {
          FetchCompanyTickets(selectedCompany.value);
          setRefreshButtonLabel("Refresh Partner Data");
        } else {
          setRefreshButtonLabel("Refresh All Data");
        }
      } else {
        setRefreshButtonLabel("Refresh All Data");
      }
    }
  }, [selectedCompany, isFilterShow]);

  useEffect(() => {
    setPageNumber(response?.page);
  }, [response]);

  return (
    <>
      <Card className="mb-3">
        <SikkaCardHeader
          title={
            <>
              <FontAwesomeIcon className="mr-2" icon={faTicket} /> {HeaderTitle}
            </>
          }
        >
          <ButtonIcon
            color="outline-primary"
            size="sm"
            icon="Sync"
            className="ml-1 mt-lg-0 mb-2"
            iconClassName="fs--2"
            onClick={() => {
              setIsFilterShow(!isFilterShow);
            }}
          >
            <FontAwesomeIcon style={{ marginRight: "5px" }} icon={faFilter} />
            Filter
          </ButtonIcon>

          <ButtonIcon
            color="outline-primary"
            size="sm"
            icon="Sync"
            className="ml-1 mt-lg-0 mb-2"
            iconClassName="fs--2"
            onClick={() => {
              if (isFilterShow) {
                if (selected_status && CompanyName) {
                  let findStatusIndex = QueryList.findIndex(
                    (item) => item.name === selected_status
                  );
                  let formatQuery =
                    `company_name:'${CompanyName}' AND ` +
                    QueryList[findStatusIndex].query;

                  // setCustomLink(formatQuery);
                  FetchFilterAPI(formatQuery);
                } else {
                  sessionStorage.removeItem("selected_status");
                  FetchFilterAPI(customLink);
                }
              } else {
                // sessionStorage.removeItem("selected_status");
                if (loginUserDetails.is_partner === "0") {
                  if (selectedCompany.value === "All") {
                    FetchData(null, 100, pageNumber, 1000);
                  } else {
                    FetchCompanyTickets(
                      selectedCompany.value,
                      100,
                      pageNumber,
                      100
                    );
                  }
                } else {
                  FetchData(
                    loginUserDetails?.freshdesk_id,
                    100,
                    pageNumber,
                    100
                  );
                }
              }
            }}
          >
            <FontAwesomeIcon style={{ marginRight: "5px" }} icon={faSync} />
            {RefreshButtonLabel}
          </ButtonIcon>
          {backButton && backButton}
        </SikkaCardHeader>

        {isActionAllowed("liFreshdeskCompaniesButton") &&
        loginUserDetails?.is_partner === "0" ? (
          <Row className="m-2 p-1">
            <Col sm={12} lg={4} md={6} xl={4}>
              <SikkaSelect
                // styles={styles}
                classNamePrefix="react-select"
                options={companies}
                onChange={(selectedOption) => {
                  setSelectedCompany(selectedOption);
                  if (loginUserDetails?.is_partner === "0") {
                    sessionStorage.setItem(
                      "lastSelected",
                      JSON.stringify(selectedOption)
                    );
                  }
                }}
                // value={companies && {id:companies[0]?.id,label:companies[0]?.label}}
                defaultValue={selectedCompany}
              />
            </Col>
          </Row>
        ) : (
          <></>
        )}

        {((loginUserDetails.is_partner === "0" &&
          selectedCompany.value !== "All") ||
          companyid ||
          loginUserDetails.is_partner === "1") &&
          !isFilterShow && (
            <Row className="m-2 p-1">
              <Col sm={12} lg={4} className="d-flex justify-content-start" />

              <Col sm={12} lg={8} className="d-flex justify-content-end">
                <span>
                  {"Page : "}
                  <Badge bg="secondary" className="mr-3">
                    {pageNumber}
                  </Badge>
                </span>

                <ButtonIcon
                  color="outline-primary"
                  size="sm"
                  icon="Sync"
                  className="ml-1 mt-lg-0 mb-2"
                  iconClassName="fs--2"
                  onClick={() => {
                    let countPageNumber = pageNumber - 1;
                    setPageNumber(countPageNumber);
                    if (loginUserDetails?.is_partner === "1") {
                      FetchCompanyTickets(null, 100, countPageNumber, 100);
                    } else {
                      FetchCompanyTickets(
                        companyid || selectedCompany?.value,
                        100,
                        countPageNumber,
                        100
                      );
                    }
                  }}
                  disabled={!(pageNumber > 1)}
                >
                  <FontAwesomeIcon
                    style={{ marginRight: "5px" }}
                    icon={faArrowLeft}
                  />
                  Previous
                </ButtonIcon>

                <ButtonIcon
                  color="outline-primary"
                  size="sm"
                  icon="Sync"
                  className="ml-1 mt-lg-0 mb-2"
                  iconClassName="fs--2"
                  onClick={() => {
                    let countPageNumber = pageNumber + 1;
                    setPageNumber(countPageNumber);
                    if (loginUserDetails?.is_partner === "1") {
                      FetchCompanyTickets(null, 100, countPageNumber, 100);
                    } else {
                      FetchCompanyTickets(
                        companyid || selectedCompany?.value,
                        100,
                        countPageNumber,
                        100
                      );
                    }
                  }}
                  disabled={!(allTickets?.length > 99)}
                >
                  Next
                  <FontAwesomeIcon
                    style={{ marginLeft: "5px" }}
                    icon={faArrowRight}
                  />
                </ButtonIcon>
              </Col>
            </Row>
          )}

        <Row className="">
          <Col lg={isFilterShow ? 9 : 12}>
            <APIPortalTable
              data={allTickets}
              columns={columns}
              loading={isLoading}
              enablePagination
              CSVFileName={"tickets.csv"}
              globalFilterFn={"fuzzy"}
              state={{ pagination, showProgressBars: isLoading }}
              onPaginationChange={setPagination}
              manualPagination={false}
              initialState={{ pagination }}
            />
          </Col>
          {isFilterShow && (
            <>
              <TicketsFilter
                HeaderTitle={"Filter Tickets"}
                FetchFilterAPI={FetchFilterAPI}
                FetchData={FetchData}
                setFilterValue={setFilterValue}
                setCloseButton={setIsFilterShow}
              />
            </>
          )}
        </Row>
      </Card>
    </>
  );
};

export default Tickets;

export const CustomReactSelect = ({
  label,
  options,
  GetSelectedOption,
  rest,
  isMultipleSelect,
}) => {
  let isOptionsContainsIdAndLable =
    options.length > 0
      ? Object.keys(options[0]).includes("id") ||
        Object.keys(options[0]).includes("label")
        ? true
        : false
      : false;
  options = !isOptionsContainsIdAndLable
    ? [...options].map((option, index) => {
        return { id: index, label: option };
      })
    : [...options];

  return (
    <>
      <Row className="mb-1">
        <Col>
          <label htmlFor={`${label}`}>{label}</label>
          <SikkaSelect
            {...rest}
            classNamePrefix="react-select"
            options={options.map((option, index) => {
              return {
                value: option?.id,
                label: `${option?.label}`,
              };
            })}
            isMulti={isMultipleSelect}
            isSearchable={true}
            onChange={(selectedOption) => {
              if (GetSelectedOption) {
                GetSelectedOption(selectedOption);
              }
            }}
          />
        </Col>
      </Row>
    </>
  );
};

// IN FILTER DATA ID IS VALUE SO YOU HAVE TO DEFINE REAL VALUE  IN ID PROPERTY. SEE EXAMPLE IN created_at
const filterData = [
  {
    filterName: "status",
    filterOptions: statusData,
    GetSelectedOption: (e) => {},
    isMultipleSelect: true,
    defaultValue: {},
  },
  {
    filterName: "priority",
    filterOptions: priorityData,
    GetSelectedOption: (e) => {},
    isMultipleSelect: true,
    defaultValue: {},
  },
  {
    filterName: "created_at",
    filterOptions: [
      { id: 0, label: "Today" },
      { id: 1, label: "Yesterday" },
      { id: 7, label: "This Week" },
      { id: 8, label: "  Last 7 Days" },
      { id: 31, label: "This Month" },
      { id: 30, label: "Last 30 Days" },
      { id: 60, label: "Last 60 Days" },
      { id: 180, label: "Last 180 Days" },
    ],
    GetSelectedOption: (e) => {},
    isMultipleSelect: true,
    defaultValue: {},
  },
  // {
  //   filterName: "updated_at",
  //   filterOptions: [
  //     { id: 0, label: "Today" },
  //     { id: 1, label: "Yesterday" },
  //     { id: 7, label: "This Week" },
  //     { id: 8, label: "  Last 7 Days" },
  //     { id: 31, label: "This Month" },
  //     { id: 30, label: "Last 30 Days" },
  //     { id: 60, label: "Last 60 Days" },
  //     { id: 180, label: "Last 180 Days" },
  //   ],
  //   GetSelectedOption: (e) => {},
  //   isMultipleSelect: true,
  //   defaultValue: {},
  // },
  {
    filterName: "due_by",
    filterOptions: [
      { id: 0, label: "Today" },
      { id: 1, label: "Yesterday" },
      { id: 7, label: "This Week" },
      { id: 8, label: "  Last 7 Days" },
      { id: 31, label: "This Month" },
      { id: 30, label: "Last 30 Days" },
      { id: 60, label: "Last 60 Days" },
      { id: 180, label: "Last 180 Days" },
    ],
    GetSelectedOption: (e) => {},
    isMultipleSelect: true,
    defaultValue: {},
  },
  // {
  //   filterName: "fr_due_by",
  //   filterOptions: [
  //     { id: 0, label: "Today" },
  //     { id: 1, label: "Yesterday" },
  //     { id: 7, label: "This Week" },
  //     { id: 8, label: "  Last 7 Days" },
  //     { id: 31, label: "This Month" },
  //     { id: 30, label: "Last 30 Days" },
  //     { id: 60, label: "Last 60 Days" },
  //     { id: 180, label: "Last 180 Days" },
  //   ],
  //   GetSelectedOption: (e) => {},
  //   isMultipleSelect: true,
  //   defaultValue: {},
  // },
  {
    filterName: "type",
    filterOptions: ["Question", "Problem", "Task"].map((item) => {
      return { id: item, label: item };
    }),
    GetSelectedOption: (e) => {},
    isMultipleSelect: true,
    defaultValue: {},
  },
  // {
  //   filterName: "source",
  //   filterOptions: [
  //     { id: 1, label: "Email" },
  //     { id: 2, label: "Portal" },
  //     { id: 3, label: "Phone" },
  //     { id: 7, label: "Chat" },
  //     { id: 9, label: "Feedback Widget" },
  //     { id: 10, label: "Outbound Email" },
  //   ],
  //   GetSelectedOption: (e) => {},
  //   isMultipleSelect: true,
  //   defaultValue: {},
  // },
];
const TicketsFilter = ({
  HeaderTitle,
  setFilterValue,
  FetchFilterAPI,
  FetchData,
  setCloseButton,
}) => {
  const [Value, setValue] = useState({});

  useEffect(() => {
    setFilterValue(Value);
  }, [Value]);

  // const ResetFunction = () => {
  //   FetchData();
  //   setValue({});
  //   setFilterValue({});
  //   sessionStorage.removeItem("selected_status");
  // };
  return (
    <>
      <Col lg={3}>
        <Card className="mr-3 mt-1 mb-1 h-auto border">
          <SikkaCardHeader title={HeaderTitle}>
            <ButtonIcon
              color="outline-danger"
              size="sm"
              icon="close"
              className="rounded"
              iconClassName="fs--2"
              onClick={() => {
                setCloseButton(false);
              }}
            >
              <FontAwesomeIcon icon={faClose} />
              {/* Close */}
            </ButtonIcon>
          </SikkaCardHeader>

          <CardBody className="freshdesk-tickets-filter-container">
            <Row>
              <Col>
                {filterData.map((filterItem) => {
                  return (
                    <>
                      <CustomReactSelect
                        label={filterItem.filterName}
                        options={filterItem.filterOptions}
                        isMultipleSelect={filterItem.isMultipleSelect}
                        GetSelectedOption={(e) => {
                          setValue({ ...Value, [filterItem.filterName]: e });
                        }}
                      />
                    </>
                  );
                })}
              </Col>
            </Row>
            <Row>
              <Col>
                <ButtonIcon
                  color="outline-primary"
                  size="sm"
                  icon="Sync"
                  className="mt-2 mb-2 w-100"
                  iconClassName="fs--2"
                  onClick={FetchFilterAPI}
                >
                  Filter
                </ButtonIcon>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};
